import log from "loglevel";

export enum LocalStorageItems {
    CART = "warenkorb",
    CUSTOMER = "customer",
    BOOKMARK = "merkliste",
    CAPTCHA = "captcha",
    CAMPAIGN = "campaign"
}

export enum LocalStorageItemsLastUpdated {
    CARTLASTUPDATED = "warenkorbLastUpdated",
    CUSTOMERLASTUPDATED = "customerLastUpdated",
    BOOKMARKLASTUPDATED = "bookmarkLastUpdated",
    CAPTCHALASTUPDATED = "captchaLastUpdated",
    CAMPAIGNLASTUPDATED = "campaignLastUpdated",
}

export type LocalStorageLastUpdated = {
    [key in LocalStorageItemsLastUpdated]?: number;
};

export default interface LocalStorageProviderProps {
    logger?: log.RootLogger;
}